/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function CustomerTableConfig($translate, $mdDialog, $document, $state, $q, toast, types, utils, tkDialogs,
                                            userService, customerService, geoService) {

    var service = {
        getConfig: getConfig,
    };

    return service;

    function getConfig(/*params*/) {
        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.customer,

            tableTitle: $translate.instant('customer.customers'),

            columns: [
                { key: 'createdTime',
                  title: 'entity.createdTime'},
                { key: 'title',
                  title: 'customer.title'},
                { key: 'customerSubscriptionName',
                  title: 'subscription.subscription'},
                { key: 'country',
                  title: 'contact.country'},
                { key: 'city',
                  title: 'contact.city'},
                { key: 'subCustomersCount',
                  title: 'customer.subCustomers-count'},
                { key: 'gatewaysCount',
                  title: 'customer.gateways-count'},
                { key: 'devicesCount',
                  title: 'customer.devices-count'}
            ],

            addEntityController: 'AddCustomerController',

            loadEntities: () => {return customerService.getCustomers();},
            loadEntity: (entityId) => {return getCustomer(entityId);},
            saveEntity: (entity) => {return saveCustomer(entity);},
            deleteEntity: (entityId) => {return customerService.deleteCustomer(entityId);},

            manageGatewayGroups: (event, entity) => {
                manageGatewayGroups(event, entity);
            },
            manageUsers: (event, entity) => {
                manageUsers(event, entity);
            },
            
            addEnabled: () => {
                return access == types.access.admin;
            },
            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('customer.delete-customer-title', {title: entity.title});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('customer.delete-customer-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('customer.delete-customers-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('customer.delete-customers-text');
            }
        };

        tableConfiguration.actionCellDescriptors = [

            {
                name: 'customer.manage-gateway-groups',
                icon: 'router',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    manageGatewayGroups($event, entity);
                }
            },
            {
                name: 'customer.manage-users',
                icon: 'account_circle',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    manageUsers($event, entity);
                }
            }
        ];

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function manageUsers($event, customer) {
        if ($event) {
            $event.stopPropagation();
        }
        $state.go('home.customers.users', {customerId: customer.id.id});
    }

    function manageGatewayGroups($event, customer) {
        if ($event) {
            $event.stopPropagation();
        }
        $state.go('home.customers.gatewayGroups', {customerId: customer.id.id});
    }

    function getCustomer(customerId) {
        var deferred = $q.defer();

        customerService.getCustomer(customerId).then(
            (customer) => {
                geoService.getResolverConfiguration(customerId).then(
                    (resolverConfiguration) => {
                        customer.resolverConfiguration = resolverConfiguration;
                        geoService.getAlgorithmConfiguration(customerId).then(
                            (algorithmConfiguration) => {
                                customer.algorithmConfiguration = algorithmConfiguration;
                                deferred.resolve(customer);
                            },
                            () => deferred.reject()
                        );
                    },
                    () => deferred.reject()
                );
            },
            () => deferred.reject()
        );

        return deferred.promise;
    }

    function saveCustomer(customer) {
        var deferred = $q.defer();
        var resolverConfiguration = customer.resolverConfiguration;
        var algorithmConfiguration = customer.algorithmConfiguration;

        customerService.saveCustomer(customer).then(
            (customer) => {
                geoService.saveResolverConfiguration(customer.id.id, resolverConfiguration).then(
                    (resolverConfiguration) => {
                        customer.resolverConfiguration = resolverConfiguration;
                        deferred.resolve(customer);
                    },
                    () => deferred.reject()
                );
                geoService.saveAlgorithmConfiguration(customer.id.id, algorithmConfiguration).then(
                    (algorithmConfiguration) => {
                        customer.algorithmConfiguration = algorithmConfiguration;
                        deferred.resolve(customer);
                    },
                    () => deferred.reject()
                );
            },
            () => deferred.reject()
        );

        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/customer/customer-table.config.js